import { environment } from "../environments/environment";

export class AppRoutes {

  // Angular components url
  public static componentsUrl = {
    base: '',
    dashboard: 'dashboard',
    registration: 'register',
    termsAndCondition: 'terms-and-condition',
    privacyPolicy: 'privacy-policy',
    login: 'login',
    logout: 'logout',
    changePassword: 'change-password',
    notFound: 'not-found',
    authValidate: 'auth-validate',
    createAccount: 'create-account'
  };

  // BackEnd Api Url
  public static backendApiUrl = {
    getStates: 'user-addresses/get-country-states',
    emailValidation: 'validate-user-basic-details',
    getFamilyMembers: 'family-groups/:familyId/member-details',
    passwordReset: 'password-reset',
    integrationsSettings: 'settings/integrations',
    portalSettings: 'settings/registration-portal',
    backgroundAndPlaceHolderSettings: 'settings/background-placeholder-settings',
    textStringSettings: 'settings/text-string-settings',
    getAppSettings: 'app-settings',
    termsAndConditionSettings: 'settings/terms-and-condition-settings',
    privacyPolicySettings: 'settings/privacy-policy-settings',
    businessInfoSettings: 'settings/business-info',
    regPortalImmediateMaintenanceMode: 'settings/tenant-maintenance-mode/customer',
    campaignUrl: '/family-groups/campaign-url/:familyId',
    communicationSettings: 'settings/communication-settings',
    staffSettings: 'settings/staff-settings',
    getStaffingSeason: 'settings/staffing-seasons',
    staffPortalAvailability: 'settings/staff-portal-available',
    twilioSettings: 'settings/twilio',
    institutions: 'settings/institutions',
    staffApplicationTypes: 'settings/staff-application-types',
    featureFlags: 'feature-flags',
    seo: 'settings/seo',
    checkCustomDomain: 'settings/custom-domain',
    sendGroupReservationStatement: 'reservation-groups/send-reservation-statement/:reservationGroupId',
  };

  // Unauthorized Urls
  public static unAuthorizedUrls = [
    `${environment.apiUrl}/settings/registration-portal`,
    `${environment.apiUrl}/refresh`,
    `${environment.apiUrl}/register`,
    `${environment.apiUrl}/login`,
    `${environment.apiUrl}/logout`,
    `${environment.apiUrl}/user-addresses/get-country-states`,
    `${environment.apiUrl}/validate-user-basic-details`,
    `${environment.apiUrl}/password-reset/change-password`,
    `${environment.apiUrl}/password-reset/validate-token`,
    `${environment.apiUrl}/password-reset`,
    `${environment.apiUrl}/settings/integration`,
    `${environment.apiUrl}/app-settings`,
    `${environment.apiUrl}/settings/background-placeholder-settings`,
    `${environment.apiUrl}/settings/text-string-settings`,
    `${environment.apiUrl}/settings/terms-and-condition-settings`,
    `${environment.apiUrl}/settings/privacy-policy-settings`,
    `${environment.apiUrl}/settings/registration-portal`,
    `${environment.apiUrl}/settings/communication-sms-settings`,
    `${environment.apiUrl}/settings/communication`,
    `${environment.apiUrl}/communication-web-view`,
    `${environment.apiUrl}/communications/get-message`,
    `${environment.apiUrl}/settings/communication-settings`,
    `${environment.apiUrl}/settings/staff-settings`,
    `${environment.apiUrl}/settings/seo`,
    `${environment.apiUrl}/settings/custom-domain`,
    `${environment.apiUrl}/settings/staffing-seasons`,
    `${environment.apiUrl}/settings/institutions`,
    `${environment.apiUrl}/auth-validate`,
    `${environment.apiUrl}/settings/twilio`,
    `${environment.loadBalancerApiUrl}/register`,
    `${environment.apiUrl}/settings/staff-application-types`,
    `${environment.apiUrl}/settings/tenant-maintenance-mode/customer`,
  ];
}
